import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable } from '@angular/core';

import { AppRoutingModule } from '@app/app.routing';
import { AppComponent } from './app.component';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from '@layout/layout.module';
import { CoreModule } from '@core/core.module';
import { PagenotfoundComponent } from '@features/pageNotFound/pagenotfound.component';
import { MaterialModule } from '@shared/material.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { MatPaginatorIntl } from '@angular/material';
import { HomeComponent } from './features/home/home/home.component';

@Injectable()
export class MatPaginator extends MatPaginatorIntl {
  itemsPerPageLabel = 'items por página';
  nextPageLabel = 'proxima';
  previousPageLabel = 'anterior';

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return '0 ' + 'de' + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = ((page * pageSize) > length) ?
      (Math.ceil(length / pageSize) - 1) * pageSize :
      page * pageSize;

    const endIndex = Math.min(startIndex + pageSize, length);
    return startIndex + 1 + ' - ' + endIndex + ' ' + 'de' + ' ' + length;
  }


}

const declarations = [
  AppComponent,
  HomeComponent,
  PagenotfoundComponent
];

const imports = [
  BrowserModule,
  BrowserAnimationsModule,
  NoopAnimationsModule,
  AppRoutingModule,
  LayoutModule,
  CoreModule,
  SharedModule,
  MaterialModule,
  NgHttpLoaderModule
];

const providers = [
  { provide: MatPaginatorIntl, useClass: MatPaginator }
];

@NgModule({
  declarations: declarations,
  imports: imports,
  providers: providers,
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule { }
